import Footer from 'compositions/footer';
import GlobalContext from 'context';
import { emitters } from 'config';
import { ConfigFooterProps } from 'interface';
import { globalCss } from 'themes';
import { globalStyles } from 'themes/globalStyles';

function App({ emissor, portal }: ConfigFooterProps): JSX.Element {
  globalCss({
    '@import': emitters[emissor].fonts,
  })();
  globalStyles();

  return (
    <GlobalContext>
      <Footer emissor={emissor} portal={portal} />
    </GlobalContext>
  );
}

export default App;
